// extracted by mini-css-extract-plugin
export var errorAnimation = "index-module--errorAnimation--76992";
export var shake = "index-module--shake--aabe3";